export const getUserTimezoneOffset = () => -new Date().getTimezoneOffset() / 60
export const getSqlTimezoneOffset = (offsetHours: number): string => {
   if (offsetHours === 0) return "utc"
   return offsetHours >= 0 ? `+${offsetHours} hours` : `${offsetHours} hours`
}

export const formatDateRelative = (
   date: Date | number | string,
   style?: Intl.RelativeTimeFormatStyle,
) => {
   // Allow dates or times to be passed
   const timeMs =
      typeof date === "number"
         ? date
         : typeof date === "string"
           ? new Date(date).getTime()
           : date.getTime()

   // Get the amount of seconds between the given date and now
   const deltaSeconds = Math.round((Date.now() - timeMs) / 1000) // Changed this line

   if (Math.abs(deltaSeconds) < 60) return "щойно"

   // Array representing one minute, hour, day, week, month, etc in seconds
   const cutoffs = [
      60,
      3600,
      86400,
      86400 * 7,
      86400 * 30,
      86400 * 365,
      Infinity,
   ]

   // Array equivalent to the above but in the string representation of the units
   const units: Intl.RelativeTimeFormatUnit[] = [
      "second",
      "minute",
      "hour",
      "day",
      "week",
      "month",
      "year",
   ]

   // Grab the ideal cutoff unit
   const unitIndex = cutoffs.findIndex(
      (cutoff) => cutoff > Math.abs(deltaSeconds),
   )

   // Get the divisor to divide from the seconds. E.g. if our unit is "day" our divisor
   // is one day in seconds, so we can divide our seconds by this to get the # of days
   const divisor = unitIndex ? cutoffs[unitIndex - 1] : 1
   const unit = units[unitIndex]

   if (!divisor || !unit) return ""

   // Intl.RelativeTimeFormat do its magic
   const rtf = new Intl.RelativeTimeFormat("uk-UA", { numeric: "auto", style })
   return rtf.format(-Math.floor(deltaSeconds / divisor), unit) // Added negative sign here
}

export const formatDate = (
   date: Date | string | number,
   options: Intl.DateTimeFormatOptions = {
      month: "short",
      day: "numeric",
      weekday: "long",
   },
) =>
   new Intl.DateTimeFormat("uk-UA", {
      ...options,
   }).format(new Date(date))
